import deceptiveProxy from '../../proxies/technical/DeceptiveProxy';
import ServiceBase from '../ServiceBase';

class DeceptiveService extends ServiceBase {
  getDataDeceptiveOverview(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'DeceptiveService.getDataDeceptiveOverview',
          params,
        )(() => deceptiveProxy.getOverview(params)),
    );
  }

  getDataDeceptiveAbnormality(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'DeceptiveService.getDataDeceptiveAbnormality',
          params,
        )(() => deceptiveProxy.getAbnormality(params)),
    );
  }

  getDataDeceptiveCancelled(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'DeceptiveService.getDataDeceptiveCancelled',
          params,
        )(() => deceptiveProxy.getCancelled(params)),
    );
  }

  getDataDeceptivePressing(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'DeceptiveService.getDataDeceptivePressing',
          params,
        )(() => deceptiveProxy.getPressing(params)),
    );
  }

  getDataDeceptiveAggressive(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'DeceptiveService.getDataDeceptiveAggressive',
          params,
        )(() => deceptiveProxy.getAggressive(params)),
    );
  }

  getDataDeceptiveClosing(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'DeceptiveService.getDataDeceptiveClosing',
          params,
        )(() => deceptiveProxy.getClosing(params)),
    );
  }
}

const deceptiveService = new DeceptiveService();
export default deceptiveService;
